/**
 * NVS Logistics logomark — inline SVG (no asset pipeline, inherits theme
 * colours, CSP-safe since it's served from our own bundle).
 *
 * A rounded "cold-chain" tile carrying a delivery-truck glyph, matching the
 * NVS Delivery Platform branding. If you have the official NVS Group logo file
 * (SVG/PNG), drop it in /src/assets and swap this component for an <img> — it
 * will be served same-origin and satisfy the app's `img-src 'self'` CSP.
 */
export function NvsLogo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 48 48"
      role="img"
      aria-label="NVS Logistics"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="nvsGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="var(--nvs)" />
          <stop offset="1" stopColor="var(--nvs-deep)" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="44" height="44" rx="12" fill="url(#nvsGrad)" />
      {/* Delivery truck */}
      <g fill="none" stroke="#ffffff" strokeWidth="2.2" strokeLinejoin="round" strokeLinecap="round">
        <path d="M11 17h13v13H11z" />
        <path d="M24 21h6l4 4v5h-10z" />
        <circle cx="17" cy="33" r="2.6" fill="#ffffff" />
        <circle cx="31" cy="33" r="2.6" fill="#ffffff" />
      </g>
      {/* Cold-chain snowflake accent */}
      <g stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" opacity="0.85">
        <line x1="34" y1="11" x2="34" y2="15" />
        <line x1="32" y1="12" x2="36" y2="14" />
        <line x1="36" y1="12" x2="32" y2="14" />
      </g>
    </svg>
  );
}
